<section class="contact-section">
  @if (showTab()) {
    <div class="contact-section__header">
      <h1 class="contact-title">{{ 'global.contact_us' | translate }}</h1>
      <pwj-section-tabs
        [tabs]="tabs"
        translateKey="aboutUs.tabs."
        [isNavigationMode]="true"></pwj-section-tabs>
    </div>
  }

  <div class="contact-section__content">
    <div class="contact-form" [ngClass]="{ '!w-full': isPortfolioMode() }">
      <h3 class="contact-form__title">
        {{ 'home.contact_us_form' | translate }}
      </h3>
      <form
        class="contact-form__box"
        [ngClass]="{ '!w-full !min-h-fit': isPortfolioMode() }"
        [formGroup]="contactForm"
        (submit)="submitContactForm()">
        <!-- form inputs -->
        <div
          class="flex flex-col gap-24"
          [ngClass]="{ '!flex-row !gap-38': isPortfolioMode() }">
          <pwj-input
            [ngClass]="{ 'w-full': isPortfolioMode() }"
            icon="user-1"
            iconPosition="left"
            placeholder="global.enter_your_full_Name"
            label="global.full_Name"
            formControlName="name"></pwj-input>
          <!-- phone number input -->
          <pwj-phone-number
            [ngClass]="{ 'w-full mt-10': isPortfolioMode() }"
            icon="phone"
            iconPosition="left"
            placeholder="global.enter_your_phone"
            label="global.phone_number"
            formControlName="mobile"></pwj-phone-number>
          <pwj-input
            [ngClass]="{ 'w-full': isPortfolioMode() }"
            icon="mail"
            iconPosition="left"
            placeholder="global.enter_your_email"
            label="global.email"
            formControlName="email"></pwj-input>
        </div>

        <!-- description input -->
        <pwj-input
          icon="stickynote"
          iconPosition="left"
          [isTextAreaMode]="true"
          placeholder="global.description"
          label="global.description"
          rows="3"
          formControlName="description">
        </pwj-input>

        <!-- submit btn -->
        <div class="form-btn-container">
          <pwj-button
            variant="primary"
            size="large"
            icon="chevron-right"
            [rotateIconInRtl]="true"
            [iconReversePosition]="true"
            type="submit"
            [disabled]="contactForm.invalid || isDisabledSubmitBtn"
            >{{ 'global.confirmation' | translate }}</pwj-button
          >
        </div>
      </form>
    </div>
    <div class="contact-map" [hidden]="isPortfolioMode()">
      <h3 class="contact-map__title">{{ 'global.location' | translate }}</h3>
      <div class="contact-map__map-box">
        <pwj-map-box [location]="companyLocation"></pwj-map-box>
      </div>
    </div>
    <div class="contact-info" [hidden]="isPortfolioMode()">
      <h3 class="contact-info__title">{{ 'global.contacts' | translate }}</h3>
      <div class="contact-info__box">
        <ul class="info-list">
          @for (info of contactData(); track $index) {
            @if (info.description) {
              <li class="info-list__item">
                <div class="info-name">
                  <i
                    class="info-name__icon iconsax"
                    [attr.icon-name]="info.icon"></i>
                  <span class="info-name__text">{{
                    info.title | translate
                  }}</span>
                </div>
                <p
                  class="info-description {{ info?.descriptionClasses }}"
                  [ngClass]="{
                    'info-description--is-ltr': info?.isNumberMode,
                  }">
                  {{ (info.description | translateData) || '' | translate }}
                </p>
              </li>
            }
          }
        </ul>
      </div>
    </div>
  </div>
</section>
